import { render, staticRenderFns } from "./SKProductDetails.vue?vue&type=template&id=9e6a4446&"
var script = {}
import style0 from "./SKProductDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports